// extracted by mini-css-extract-plugin
export default {"zoomModal":"f2-z","image":"g2-z","button":"h2-z","isOverlayShown":"i2-z"};